import { FC } from 'react'

import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded'
import { alpha, Box } from '@mui/material'

import { GAME_ICON_RADIUS, gameIconSx } from './styles'

/**
 * Small rounded game icon used to lead a delta-column header (e.g. before
 * "Monthly Δ"), so two same-named columns are told apart by their icon. Renders
 * nothing when no `src` is supplied so callers can pass it unconditionally.
 */
export const HeaderGameIcon: FC<{ src?: string | null; alt?: string }> = ({ src, alt = '' }) =>
  src ? <Box component="img" src={src} alt={alt} sx={gameIconSx(18, { background: false })} /> : null

/**
 * Small category badge standing in for a genre (which has no icon in the
 * dataset) when leading a delta-column header. Mirrors the genre badge used in
 * the comparison matchup header, scaled down to the column-header size.
 */
export const HeaderGenreIcon: FC<{ label?: string }> = ({ label }) => (
  <Box
    role="img"
    aria-label={label}
    sx={{
      width: 18,
      height: 18,
      borderRadius: GAME_ICON_RADIUS,
      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
      color: 'primary.main',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <CategoryRoundedIcon sx={{ fontSize: 12 }} />
  </Box>
)
